import { create } from "../../../../../common/utils/zustand_state_manager";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";
import { CentroCustoDropDown } from "../../../../../common/domain/models/centro_custo_dropdown";

type State = {
  IdEntradaProduto: number;
  FornecedorPesquisa: number;
  ProdutoPesquisa: number;
  pesquisa: string | null;
  ordemCompra: number[];
  centroDeCusto: number[];
  centroDeCustoLista: CentroCustoDropDown[] | undefined;
  dataEntradaDe: Date | null,
  dataEntradaAte: Date | null,
};

type Action = {
  setFilters: (filters: Partial<State>) => void;
  clearFilters: () => void;
  setFornecedorPesquisa: SetFunction<number>;
  setProdutoPesquisa: SetFunction<number>;
  setPesquisa: SetFunction<string | null>;
  setCentroDeCusto: SetFunction<number[]>;
  setCentroDeCustoLista: SetFunction<CentroCustoDropDown[]>;
};

export const initialFiltersValues: State = {
  IdEntradaProduto: 0,
  FornecedorPesquisa: 0,
  ProdutoPesquisa: 0,
  pesquisa: "",
  ordemCompra: [],
  centroDeCusto: [],
  centroDeCustoLista: undefined,
  dataEntradaDe: null,
  dataEntradaAte: null,

};

export const useEntradaProdutoFilters = create<State & Action>((set) => ({
  ...initialFiltersValues,
  setPesquisa: (vfn) => SetFunctionImpl(set, 'pesquisa', vfn),
  setProdutoPesquisa: (vfn) => SetFunctionImpl(set, 'ProdutoPesquisa', vfn),
  setCentroDeCusto: (vfn) => SetFunctionImpl(set, 'centroDeCusto', vfn),
  setCentroDeCustoLista: (vfn) => SetFunctionImpl(set, 'centroDeCustoLista', vfn),
  setFornecedorPesquisa: (vfn) => SetFunctionImpl(set, 'FornecedorPesquisa', vfn),
  setFilters: (filters) => set((state) => ({ ...state, ...filters })),
  clearFilters: () => set((state) => ({
    ...initialFiltersValues,
    centroDeCustoLista: state.centroDeCustoLista
  })),
}));
